module.exports = __webpack_public_path__ + "static/media/header_image_2.e3b8617d.jpg";